export default (data, field) => {
  let result = {};
  let count = 0;
  for (let i = 0; i < data.length; i++) {
    if (!result[data[i][field]]) {
      result[data[i][field]] = {};
      result[data[i][field]].total = 0;
      result[data[i][field]].from = count;
    }
    result[data[i][field]].total += 1;
    count += 1;
  }
  return result;
};
